
export default {
    props: {
        dataset : Array,
        title: String
    },
}
